import React from "react";

const Analytics = () => {
  return <div className="analytics">Analytics</div>;
};

export default Analytics;
